import { i18n } from '@/plugins/i18n'
import {walletWageType} from "./WalletWageType";

export const userCustomerClubLevel = {
    level_1: 1,
    level_2: 2,
    level_3: 3,
    null: null,
}

export const marketingLevelStr = {
    level_1: i18n.t('customers_club.l1'),
    level_2: i18n.t('customers_club.l2'),
    level_3: i18n.t('customers_club.l3'),
    null: i18n.t('customers_club.null'),
}

export const customerClubLevelStr = {
    level_1: i18n.t('customers_club.l1'),
    level_2: i18n.t('customers_club.l2'),
    level_3: i18n.t('customers_club.l3'),
    null: i18n.t('customers_club.null'),

    get(customersClubLevel) {
        let customers_club_level_str = null;

        Object.keys(userCustomerClubLevel).forEach(item => {
            if (userCustomerClubLevel[item] === customersClubLevel) {
                customers_club_level_str = customerClubLevelStr[item];
            }
        });

        return customers_club_level_str;
    }
};